import { render, staticRenderFns } from "./BackerCenterUpdateFeedPreview.vue?vue&type=template&id=2f396b66"
import script from "./BackerCenterUpdateFeedPreview.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports